import gql from 'graphql-tag'
import { DollarApollo } from 'vue-apollo/types/vue-apollo'
import { ITenant } from '@/graphql/tenant/interfaces/tenants'
// TODO: tenant type with id and name

export const typeDefs = gql`
  extend type Query {
    tenant: ITenant
  }
  extend type Mutation {
    updateTenant(tenant: ITenant!): ITenant
  }
`
const defaultTenant = {
  __typename: `Tenant`,
  id: ``,
  name: ``
}
const localTenant = localStorage.getItem(`tenant`)

export const resolvers = {
  Query: {
    tenant(_: any, __: any, { cache }: { cache: any }) {
      const { tenant } = cache.readQuery({ query })
      return tenant
    }
  },
  Mutation: {
    updateTenant: (
      _: any,
      { tenant }: { tenant: ITenant },
      { cache }: { cache: any }
    ) => {
      const data = cache.readQuery({ query })
      cache.writeQuery({
        query,
        data: {
          ...data,
          tenant
        }
      })
      localStorage.setItem(
        `tenant`,
        JSON.stringify({
          ...tenant,
          name: ``
        })
      )
    }
  }
}

export const hydrate = {
  tenant: localTenant ? JSON.parse(localTenant) : defaultTenant
}

export const query = gql`
  query Tenant {
    tenant @client {
      id
      name
    }
  }
`

export const mutation = gql`
  mutation updateTenant($tenant: ITenant!) {
    updateTenant(tenant: $tenant) @client
  }
`

export default {
  typeDefs,
  resolvers,
  hydrate
}

export const mutateTenant = (
  { tenant }: { tenant: ITenant },
  apollo: DollarApollo<any>
) => {
  return new Promise(async resolve => {
    await apollo.mutate({
      mutation,
      variables: { tenant }
    })
    resolve()
  })
}
